import {
  checkSession,
  login,
  impersonateLogin,
  logout,
  confirmSignUp,
  resendSignUp,
  forgotPassword,
  forgotPasswordSubmit,
  changePassword,
  resetError,
} from '../actions/user';

const initialState = {
  data: null,
  loading: false,
  error: null,
  checkingSession: true,
  forgotPasswordSubmitError: null,
};

export default (state = initialState, action: any) => {
  switch (action.type) {
    case resetError.TRIGGER:
      return { ...state, error: null };

    case checkSession.REQUEST:
      return {
        ...state,
        data: null,
        checkingSession: true,
        error: null,
      };

    case login.REQUEST:
    case impersonateLogin.REQUEST:
    case confirmSignUp.REQUEST:
    case resendSignUp.REQUEST:
    case forgotPassword.REQUEST:
    case forgotPasswordSubmit.REQUEST:
      return {
        ...state,
        data: null,
        error: null,
        loading: true,
        forgotPasswordSubmitError: null,
      };
    case logout.REQUEST:
    case changePassword.REQUEST:
      return {
        ...state,
        error: null,
      };

    case checkSession.SUCCESS:
    case login.SUCCESS:
    case impersonateLogin.SUCCESS:
    case confirmSignUp.SUCCESS:
      return { ...state, data: action.payload };
    case checkSession.FAILURE:
    case logout.SUCCESS:
      return { ...state, data: null };

    case login.FAILURE:
    case impersonateLogin.FAILURE:
    case logout.FAILURE:
    case confirmSignUp.FAILURE:
    case resendSignUp.FAILURE:
    case forgotPassword.FAILURE:
    case changePassword.FAILURE:
      return { ...state, error: action.payload };

    case forgotPasswordSubmit.FAILURE:
      return { ...state, forgotPasswordSubmitError: action.payload };

    case login.FULFILL:
    case impersonateLogin.FULFILL:
    case confirmSignUp.FULFILL:
    case resendSignUp.FULFILL:
    case forgotPassword.FULFILL:
    case forgotPasswordSubmit.FULFILL:
      return { ...state, loading: false };

    case checkSession.FULFILL:
      return { ...state, checkingSession: false };

    default:
      return state;
  }
};
